"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadHelpFile = exports.checkValueForNA = exports.getPattern = exports.getTab = exports.getTabs = exports.convertDateToEpoch = exports.convertEpochToDate = exports.getLabelWithValueForModifiedLabel = exports.getLabelWithValue = exports.dispatchMultipleFieldChangeAction = exports.getDivider = exports.getCommonContainer = exports.getRadioButton = exports.getRadiobuttonGroup = exports.getRadiobuttonwithLabel = exports.getCheckBoxwithLabel = exports.getLocaleLabelsforTL = exports.getTextField = exports.getDateTimeField = exports.getTimeField = exports.getDateField = exports.getSelectField = exports.getLabelForModify = exports.getLabel = exports.getBreak = exports.getCommonCardWithNoShadow = exports.getCommonGrayCard = exports.getCommonCardWithHeader = exports.getCommonCard = exports.getCommonLabelValue = exports.getCommonLabelWithValue = exports.getCommonValue = exports.getCommonCaption = exports.getCommonParagraph = exports.getCommonSubHeader = exports.getCommonTitle = exports.getCommonHeader = exports.getStepperObject = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("../../../../ui-redux/screen-configuration/actions");

var _commons = require("../../../../ui-utils/commons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appCardHeaderStyle = function appCardHeaderStyle() {
  var colorOne = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#ec407a";
  var colorTwo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#d81b60";

  return {
    color: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50px",
    padding: "15px",
    marginTop: "-36px",
    borderRadius: "3px",
    background: "linear-gradient(60deg," + colorOne + " ," + colorTwo + " )",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)"
  };
};

var getStepperObject = exports.getStepperObject = function getStepperObject(stpperProps, stepsData) {
  var uiFramework = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "material-ui";

  var stepperData = {};
  if (uiFramework === "material-ui") {
    stepperData = {
      componentPath: "Stepper",
      uiFramework: "custom-molecules",
      props: (0, _extends3.default)({
        steps: stepsData
      }, stpperProps.props)
    };
  }
  return stepperData;
};

var getCommonHeader = exports.getCommonHeader = function getCommonHeader(header, props) {
  return {
    componentPath: "Typography",
    props: (0, _extends3.default)({
      variant: "headline"
    }, props),
    children: {
      // [header]: getLabel(header)
      key: getLabel(header)
    }
  };
};

var getCommonTitle = exports.getCommonTitle = function getCommonTitle(header) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return getCommonHeader(header, (0, _extends3.default)({ variant: "title" }, props));
};

var getCommonSubHeader = exports.getCommonSubHeader = function getCommonSubHeader(header) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return getCommonHeader(header, (0, _extends3.default)({ variant: "subheading" }, props));
};

var getCommonParagraph = exports.getCommonParagraph = function getCommonParagraph(paragraph) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Div",
    props: (0, _extends3.default)({
      style: {
        color: "rgba(0, 0, 0, 0.60)",
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        marginBottom: "12px",
        position: "relative",
        top: "1px",
        flex: "none"
      }
    }, props),

    children: (0, _defineProperty3.default)({}, paragraph, getLabel(paragraph))
  };
  // getCommonHeader(paragraph, { variant: "body1", ...props });
};

var getCommonCaption = exports.getCommonCaption = function getCommonCaption(paragraph) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return getCommonHeader(paragraph, (0, _extends3.default)({ variant: "caption" }, props));
};

var getCommonValue = exports.getCommonValue = function getCommonValue(value) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return getCommonHeader(value, (0, _extends3.default)({ variant: "body2" }, props));
};

var getCommonLabelWithValue = exports.getCommonLabelWithValue = function getCommonLabelWithValue(paragraph, value) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return getCommonLabelValue(paragraph, value, (0, _extends3.default)({ variant: "caption" }, props));
};

var getCommonLabelValue = exports.getCommonLabelValue = function getCommonLabelValue(header, value, props) {
  return {
    componentPath: "Typography",
    props: (0, _extends3.default)({
      variant: "headline"
    }, props),
    children: {
      // [header]: getLabel(header)
      key: getLabelForModify(header, value)
    }
  };
};

var getCommonCard = exports.getCommonCard = function getCommonCard(children) {
  var cardProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cardContentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    componentPath: "Card",
    props: (0, _extends3.default)({}, cardProps),
    children: {
      cardContent: {
        componentPath: "CardContent",
        props: (0, _extends3.default)({}, cardContentProps),
        children: children
      }
    }
  };
};

var getCommonCardWithHeader = exports.getCommonCardWithHeader = function getCommonCardWithHeader(children) {
  var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cardProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return getCommonCard({
    cardContainer: {
      uiFramework: "custom-atoms",
      componentPath: "Container",
      children: {
        header: {
          uiFramework: "custom-atoms",
          componentPath: "Div",
          props: {
            style: appCardHeaderStyle()
          },
          children: header,
          gridDefination: {
            xs: 12
          }
        },
        body: {
          uiFramework: "custom-atoms",
          componentPath: "Div",
          children: children,
          gridDefination: {
            xs: 12
          }
        }
      }
    }
  });
};

var getCommonGrayCard = exports.getCommonGrayCard = function getCommonGrayCard(children) {
  return getCommonCard(children, {
    style: {
      backgroundColor: "rgb(242, 242, 242)",
      boxShadow: "none",
      borderRadius: 0,
      overflow: "visible"
    }
  });
};
var getCommonCardWithNoShadow = exports.getCommonCardWithNoShadow = function getCommonCardWithNoShadow(children) {
  return getCommonCard(children, {
    style: {
      boxShadow: "none",
      borderRadius: 0,
      overflow: "visible"
    }
  });
};

var getBreak = exports.getBreak = function getBreak() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Break",
    props: props
  };
};

var getLabel = exports.getLabel = function getLabel(label, labelKey) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    uiFramework: "custom-containers",
    componentPath: "LabelContainer",
    props: (0, _extends3.default)({}, label, props)
  };
};

var getLabelForModify = exports.getLabelForModify = function getLabelForModify(label, jsonPath) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    uiFramework: "custom-containers",
    componentPath: "ModifyLabelConatiner",
    props: (0, _extends3.default)({}, label, jsonPath, props)
  };
};

var getSelectField = exports.getSelectField = function getSelectField(selectScheama) {
  return getTextField((0, _extends3.default)({}, selectScheama, {
    props: (0, _extends3.default)({ select: true }, selectScheama.props)
  }));
};

var getDateField = exports.getDateField = function getDateField(dateScheama) {
  return getTextField((0, _extends3.default)({}, dateScheama, {
    props: (0, _extends3.default)({
      type: "date"
    }, dateScheama.props)
  }));
};

var getTimeField = exports.getTimeField = function getTimeField(timeScheama) {
  return getTextField((0, _extends3.default)({}, timeScheama, {
    props: (0, _extends3.default)({
      type: "time"
    }, timeScheama.props)
  }));
};

var getDateTimeField = exports.getDateTimeField = function getDateTimeField(dateTimeScheama) {
  return getTextField((0, _extends3.default)({}, dateTimeScheama, {
    props: (0, _extends3.default)({
      type: "datetime-local"
    }, dateTimeScheama.props)
  }));
};

var getTextField = function getTextField(textScheama) {
  var _textScheama$label = textScheama.label,
      label = _textScheama$label === undefined ? {} : _textScheama$label,
      _textScheama$placehol = textScheama.placeholder,
      placeholder = _textScheama$placehol === undefined ? {} : _textScheama$placehol,
      _textScheama$localePr = textScheama.localePrefix,
      localePrefix = _textScheama$localePr === undefined ? {} : _textScheama$localePr,
      _textScheama$required = textScheama.required,
      required = _textScheama$required === undefined ? false : _textScheama$required,
      pattern = textScheama.pattern,
      _textScheama$jsonPath = textScheama.jsonPath,
      jsonPath = _textScheama$jsonPath === undefined ? "" : _textScheama$jsonPath,
      _textScheama$sourceJs = textScheama.sourceJsonPath,
      sourceJsonPath = _textScheama$sourceJs === undefined ? "" : _textScheama$sourceJs,
      _textScheama$cityDrop = textScheama.cityDropdown,
      cityDropdown = _textScheama$cityDrop === undefined ? "" : _textScheama$cityDrop,
      _textScheama$data = textScheama.data,
      data = _textScheama$data === undefined ? [] : _textScheama$data,
      _textScheama$optionVa = textScheama.optionValue,
      optionValue = _textScheama$optionVa === undefined ? "code" : _textScheama$optionVa,
      _textScheama$optionLa = textScheama.optionLabel,
      optionLabel = _textScheama$optionLa === undefined ? "code" : _textScheama$optionLa,
      _textScheama$iconObj = textScheama.iconObj,
      iconObj = _textScheama$iconObj === undefined ? {} : _textScheama$iconObj,
      _textScheama$gridDefi = textScheama.gridDefination,
      gridDefination = _textScheama$gridDefi === undefined ? {
    xs: 12,
    sm: 6
  } : _textScheama$gridDefi,
      _textScheama$props = textScheama.props,
      props = _textScheama$props === undefined ? {} : _textScheama$props,
      minLength = textScheama.minLength,
      maxLength = textScheama.maxLength,
      minValue = textScheama.minValue,
      maxValue = textScheama.maxValue,
      infoIcon = textScheama.infoIcon,
      _textScheama$title = textScheama.title,
      title = _textScheama$title === undefined ? {} : _textScheama$title,
      _textScheama$multilin = textScheama.multiline,
      multiline = _textScheama$multilin === undefined ? false : _textScheama$multilin,
      _textScheama$rows = textScheama.rows,
      rows = _textScheama$rows === undefined ? "1" : _textScheama$rows,
      _textScheama$disabled = textScheama.disabled,
      disabled = _textScheama$disabled === undefined ? false : _textScheama$disabled,
      _textScheama$errorMes = textScheama.errorMessage,
      errorMessage = _textScheama$errorMes === undefined ? "" : _textScheama$errorMes,
      _textScheama$required2 = textScheama.requiredMessage,
      requiredMessage = _textScheama$required2 === undefined ? "" : _textScheama$required2,
      rest = (0, _objectWithoutProperties3.default)(textScheama, ["label", "placeholder", "localePrefix", "required", "pattern", "jsonPath", "sourceJsonPath", "cityDropdown", "data", "optionValue", "optionLabel", "iconObj", "gridDefination", "props", "minLength", "maxLength", "minValue", "maxValue", "infoIcon", "title", "multiline", "rows", "disabled", "errorMessage", "requiredMessage"]);

  return (0, _extends3.default)({
    uiFramework: "custom-containers",
    componentPath: "TextFieldContainer",
    props: (0, _extends3.default)({
      label: label,
      InputLabelProps: {
        shrink: true
      },
      placeholder: placeholder,
      localePrefix: localePrefix,
      fullWidth: true,
      required: required,
      data: data,
      optionValue: optionValue,
      optionLabel: optionLabel,
      sourceJsonPath: sourceJsonPath,
      cityDropdown: cityDropdown,
      jsonPath: jsonPath,
      iconObj: iconObj,
      title: title,
      disabled: disabled,
      multiline: multiline,
      rows: rows,
      infoIcon: infoIcon,
      errorMessage: errorMessage
    }, props),
    gridDefination: gridDefination,
    required: required,
    pattern: pattern,
    jsonPath: jsonPath,
    minLength: minLength,
    maxLength: maxLength,
    minValue: minValue,
    maxValue: maxValue,
    errorMessage: errorMessage,
    requiredMessage: requiredMessage
  }, rest);
};

exports.getTextField = getTextField;
var getLocaleLabelsforTL = exports.getLocaleLabelsforTL = function getLocaleLabelsforTL(label, labelKey, localizationLabels) {
  if (labelKey) {
    var translatedLabel = (0, _commons.getTranslatedLabel)(labelKey, localizationLabels);
    if (!translatedLabel || labelKey === translatedLabel) {
      return label;
    } else {
      return translatedLabel;
    }
  } else {
    return label;
  }
};

var getCheckBoxwithLabel = exports.getCheckBoxwithLabel = function getCheckBoxwithLabel(label) {
  var gridDefination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    xs: 12,
    sm: 12
  };
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Div",
    gridDefination: gridDefination,
    props: props,
    children: {
      div: {
        uiFramework: "material-ui",
        componentPath: "Checkbox",
        props: {
          color: "primary"
        }
      },
      label: getLabel(label)
    }
  };
};

var getRadiobuttonwithLabel = exports.getRadiobuttonwithLabel = function getRadiobuttonwithLabel(label) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Div",
    props: props,
    children: {
      div: {
        uiFramework: "material-ui",
        componentPath: "Radio",
        props: {
          color: "primary"
        }
      },
      label: getLabel(label)
    }
  };
};

var getRadiobuttonGroup = exports.getRadiobuttonGroup = function getRadiobuttonGroup(labels) {
  var gridDefination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    xs: 12,
    sm: 12
  };

  return {
    uiFramework: "custom-atoms",
    componentPath: "Container",
    gridDefination: gridDefination,
    children: labels && labels.map(function (label) {
      return getRadiobuttonwithLabel(label);
    })
  };
};

var getRadioButton = exports.getRadioButton = function getRadioButton(buttons, jsonPath, defaultValue) {
  return {
    uiFramework: "custom-containers",
    componentPath: "RadioGroupContainer",
    gridDefination: {
      xs: 12,
      sm: 4
    },

    props: {
      buttons: buttons,
      jsonPath: jsonPath,
      defaultValue: defaultValue
    },
    jsonPath: jsonPath
  };
};

var getCommonContainer = exports.getCommonContainer = function getCommonContainer(children) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    componentPath: "Grid",
    props: (0, _extends3.default)({
      container: true
    }, props),
    children: children
  };
};

var getDivider = exports.getDivider = function getDivider() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    componentPath: "Divider",
    props: props
  };
};

var dispatchMultipleFieldChangeAction = exports.dispatchMultipleFieldChangeAction = function dispatchMultipleFieldChangeAction(screenKey) {
  var actionDefination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var dispatch = arguments[2];

  for (var i = 0; i < actionDefination.length; i++) {
    var _actionDefination$i = actionDefination[i],
        path = _actionDefination$i.path,
        property = _actionDefination$i.property,
        value = _actionDefination$i.value;

    dispatch((0, _actions.handleScreenConfigurationFieldChange)(screenKey, path, property, value));
  }
};

var getLabelWithValue = exports.getLabelWithValue = function getLabelWithValue(label, value) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Div",
    gridDefination: {
      xs: 6,
      sm: 3
    },
    props: (0, _extends3.default)({
      style: {
        marginBottom: "16px",
        wordBreak: "break-word"
      }
    }, props),
    children: {
      label: getCommonCaption(label),
      value: getCommonValue(value)
    }
  };
};

var getLabelWithValueForModifiedLabel = exports.getLabelWithValueForModifiedLabel = function getLabelWithValueForModifiedLabel(label, value, label2, value2) {
  var props = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  return {
    uiFramework: "custom-atoms",
    componentPath: "Div",
    gridDefination: {
      xs: 6,
      sm: 3
    },
    props: (0, _extends3.default)({
      style: {
        marginBottom: "16px",
        wordBreak: "break-word"
      }
    }, props),
    children: {
      label1: getCommonCaption(label),
      value1: getCommonValue(value),
      label2: getCommonLabelWithValue(label2, value2)
    }
  };
};

var convertEpochToDate = exports.convertEpochToDate = function convertEpochToDate(dateEpoch) {
  // Returning null in else case because new Date(null) returns initial date from calender
  if (dateEpoch) {
    var dateFromApi = new Date(dateEpoch);
    var month = dateFromApi.getMonth() + 1;
    var day = dateFromApi.getDate();
    var year = dateFromApi.getFullYear();
    month = (month > 9 ? "" : "0") + month;
    day = (day > 9 ? "" : "0") + day;
    return day + "/" + month + "/" + year;
  } else {
    return null;
  }
};

var convertDateToEpoch = exports.convertDateToEpoch = function convertDateToEpoch(dateString) {
  var dayStartOrEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dayend";

  //example input format : "2018-10-02"
  try {
    var parts = dateString.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    var DateObj = new Date(Date.UTC(parts[1], parts[2] - 1, parts[3]));
    DateObj.setMinutes(DateObj.getMinutes() + DateObj.getTimezoneOffset());
    if (dayStartOrEnd === "dayend") {
      DateObj.setHours(DateObj.getHours() + 24);
      DateObj.setSeconds(DateObj.getSeconds() - 1);
    }
    return DateObj.getTime();
  } catch (e) {
    return dateString;
  }
};

var getTabs = exports.getTabs = function getTabs(list) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    uiFramework: "material-ui",
    componentPath: "Tabs",
    props: props,
    children: list && list.map(function (element) {
      return getTab(element);
    })
  };
};

var getTab = exports.getTab = function getTab(label) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    uiFramework: "material-ui",
    componentPath: "Tab",
    props: (0, _extends3.default)({
      label: label
    }, props)
  };
};

var getPattern = exports.getPattern = function getPattern(type) {
  switch (type) {
    case "Name":
      return (/^[^{0-9}^\$\"<>?\\\\~!@#$%^()+={}\[\]*,/_:;“”‘’]{1,50}$/i
      );
    case "SearchOwnerName":
      return (/^[^{0-9}^\$\"<>?\\\\~!@#$%^()+={}\[\]*,/_:;“”‘’]{3,50}$/i
      );
    case "MobileNo":
      return (/^[6789][0-9]{9}$/i
      );
    case "Amount":
      return (/^[0-9]{0,8}$/i
      );
    case "NonZeroAmount":
      return (/^[1-9][0-9]{0,7}$/i
      );
    case "DecimalNumber":
      return (/^\d{0,8}(\.\d{1,2})?$/i
      );
    //return /(([0-9]+)((\.\d{1,2})?))$/i;
    case "Email":
      return (/^(?=^.{1,64}$)((([^<>()\[\]\\.,;:\s$*@'"]+(\.[^<>()\[\]\\.,;:\s@'"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/i
      );
    case "Address":
      return (/^[^\$\"<>?\\\\~`!@$%^()+={}\[\]*:;“”‘’]{1,500}$/i
      );
    case "PAN":
      return (/^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/i
      );
    case "TradeName":
      return (/^[-@.\/#&+\w\s]*$/
      );
    //return /^[^\$\"'<>?\\\\~`!@#$%^()+={}\[\]*,.:;“”‘’]{1,100}$/i;
    case "Date":
      return (/^[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/i
      );
    case "UOMValue":
      return (/^(0)*[1-9][0-9]{0,5}$/i
      );
    case "OperationalArea":
      return (/^(0)*[1-9][0-9]{0,6}$/i
      );
    case "NoOfEmp":
      return (/^(0)*[1-9][0-9]{0,6}$/i
      );
    case "GSTNo":
      return (/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/i
      );
    case "DoorHouseNo":
      return (/^[^\$\"'<>?~`!@$%^={}\[\]*:;“”‘’]{1,50}$/i
      );
    case "BuildingStreet":
      return (/^[^\$\"'<>?\\\\~`!@$%^()+={}\[\]*.:;“”‘’]{1,64}$/i
      );
    case "Pincode":
      return (/^[1-9][0-9]{5}$/i
      );
    case "Landline":
      return (/^[0-9]{11}$/i
      );
    case "PropertyID":
      return (/^[a-zA-z0-9\s\\/\-]$/i
      );
    case "ElectricityConnNo":
      return (/^.{1,15}$/i
      );
    case "DocumentNo":
      return (/^[0-9]{1,15}$/i
      );
    case "eventName":
      return (/^[^\$\"<>?\\\\~`!@#$%^()+={}\[\]*,.:;“”]{1,65}$/i
      );
    case "eventDescription":
      return (/^[^\$\"'<>?\\\\~`!@$%^()+={}\[\]*.:;“”‘’]{1,500}$/i
      );
    case "cancelChallan":
      return (/^[^\$\"'<>?\\\\~`!@$%^()+={}\[\]*.:;“”‘’]{1,100}$/i
      );
    case "FireNOCNo":
      return (/^[a-zA-Z0-9-]*$/i
      );
    case "consumerNo":
      return (/^[a-zA-Z0-9/-]*$/i
      );
    case "AadharNo":
      //return /^\d{4}\s\d{4}\s\d{4}$/;
      return (/^([0-9]){12}$/
      );
    case "ChequeNo":
      return (/^(?!0{6})[0-9]{6}$/
      );
    case "Comments":
      return (/^[^\$\"'<>?\\\\~`!@$%^()+={}\[\]*.:;“”‘’]{1,50}$/i
      );
    case "OldLicenceNo":
      return (/^[a-zA-Z0-9-/]{0,64}$/
      );

  }
};

var checkValueForNA = exports.checkValueForNA = function checkValueForNA(value) {
  return value && value !== "null" ? value : "NA";
};

var downloadHelpFile = exports.downloadHelpFile = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(state) {
    var helpurl;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.info("download the help file");
            helpurl = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "helpFileUrl", "");

            window.open(helpurl, "_blank");

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function downloadHelpFile(_x29) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-config/screens/specs/utils/index.js
// module id = ../lib/egov-ui-framework/ui-config/screens/specs/utils/index.js
// module chunks = 504